import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { BatteryWarning } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-forest text-offwhite pt-24 pb-32 px-4 overflow-hidden" data-id="element-179">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-180">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-amber blur-3xl" data-id="element-181" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[60%] h-[60%] rounded-full bg-sage blur-3xl" data-id="element-182" />
      </div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-183">
        <FadeIn data-id="element-184">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-forest-light/50 border border-forest-light text-amber-light text-sm font-semibold tracking-wide uppercase mb-8" data-id="element-185">
            <BatteryWarning size={16} data-id="element-186" />
            <span data-id="element-187">Atención: Tu energía está en reserva</span>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-188">
          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl font-bold leading-tight mb-6 text-offwhite" data-id="element-189">
            Protocolo Nutri-Sync: El Fin del Agotamiento Funcional y el Hambre
            Celular
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-190">
          <h2 className="text-xl sm:text-2xl text-sage-dark font-medium leading-relaxed mb-10" data-id="element-191">
            Cómo cerrar las brechas nutricionales que el café no puede ocultar y
            recuperar tu energía biológica en 21 días.
          </h2>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-192">
          <div className="bg-forest-dark/40 border border-forest-light/30 rounded-2xl p-6 sm:p-8 text-left mb-10 shadow-2xl backdrop-blur-sm" data-id="element-193">
            <p className="text-lg leading-relaxed text-offwhite/90 mb-4" data-id="element-194">
              Te despiertas después de 8 horas de sueño y, aun así, te sientes
              como si un camión te hubiera pasado por encima. Llegas a las 3:00
              PM y tu cerebro simplemente se "apaga", dejándote en una niebla
              mental que ninguna cantidad de café logra disipar.
            </p>
            <p className="text-lg leading-relaxed text-offwhite/90" data-id="element-195">
              <strong className="text-amber-light font-semibold" data-id="element-196">
                No es falta de voluntad. No es que te estés haciendo mayor.
              </strong>{' '}
              Es algo mucho más profundo: tus células están gritando por los
              micronutrientes que el estrés y la vida moderna les han robado.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-197">
          <Button href="#pricing" data-id="element-198">
            ¡QUIERO EMPEZAR MI RESET DE ENERGÍA AHORA!
          </Button>
        </FadeIn>
      </div>
    </section>;
}